import setupAxios from './Base'

const axios = setupAxios()

export default class Logon {
  getToken(params) {
    return axios.get('/logon/getToken' + params, {
      withCredentials: true,
    })
  }

  getExternalToken(data) {
    return axios.post('/logon/loginExternalIntegration', data, {
      withCredentials: true,
    })
  }
}
